/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_EXPENSES_LIST_SUCCESS,
  LOAD_EXPENSES_LIST_ERROR,
  CREATE_EXPENSES_LIST_SUCCESS,
  CREATE_EXPENSES_LIST_ERROR,
  UPDATE_EXPENSES_LIST_SUCCESS,
  UPDATE_EXPENSES_LIST_ERROR,
  DELETE_EXPENSES_LIST_SUCCESS,
  DELETE_EXPENSES_LIST_ERROR,
  LOAD_EXPENSES_ITEMS_LIST_SUCCESS,
  LOAD_EXPENSES_ITEMS_LIST_ERROR,
  LOAD_EXPENSES_LIST_RECORDS_META_DATA_SUCCESS,
  LOAD_EXPENSES_LIST_RECORDS_META_DATA_ERROR,
  LOAD_EXPENSES_CATEGORIES_LIST_SUCCESS,
  LOAD_EXPENSES_CATEGORIES_LIST_ERROR,
  LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS_SUCCESS,
  LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS_ERROR,
  LOAD_EXPENSE_REPORT_LIST_SUCCESS,
  LOAD_EXPENSE_REPORT_LIST_ERROR,
  LOAD_CASH_BANK_REPORT_LIST_SUCCESS,
  LOAD_CASH_BANK_REPORT_LIST_ERROR,
  LOAD_PREFIX_SETTINGS_LIST_SUCCESS,
  LOAD_PREFIX_SETTINGS_LIST_ERROR,
  LOAD_FINANCIAL_YEAR_LIST_SUCCESS,
  LOAD_FINANCIAL_YEAR_LIST_ERROR,
} from "./constants";

const initialState = {
  expenses_list: [],
  expenses_categories_list: [],
  expenses_item_list: [],
  prefix_settings_list: [],
  financial_year_list: [],
  expenses_report_list: {},
  cash_bank_reports: {},
  account_transaction_list: [],
  // cash_hand_list: [],
  record: {},
  records: {},
  expenseMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    expenses_list,
    expenses_item_list,
    prefix_settings_list,
    financial_year_list,
    expenses_categories_list,
    account_transaction_list,
    expenses_report_list,
    cash_bank_reports,
    // cash_hand_list,
    record,
    expenseMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_EXPENSES_LIST_SUCCESS:
        draft.expenses_list = expenses_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PREFIX_SETTINGS_LIST_SUCCESS:
        draft.prefix_settings_list = prefix_settings_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_FINANCIAL_YEAR_LIST_SUCCESS:
        draft.financial_year_list = financial_year_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_EXPENSES_ITEMS_LIST_SUCCESS:
        draft.expenses_item_list = expenses_item_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_EXPENSE_REPORT_LIST_SUCCESS:
        draft.expenses_report_list = expenses_report_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_CASH_BANK_REPORT_LIST_SUCCESS:
        draft.cash_bank_reports = cash_bank_reports;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_EXPENSES_CATEGORIES_LIST_SUCCESS:
        draft.expenses_categories_list = expenses_categories_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS_SUCCESS:
        draft.account_transaction_list = account_transaction_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_EXPENSES_LIST_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_EXPENSES_LIST_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_EXPENSES_LIST_SUCCESS:
        draft.record = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_EXPENSES_LIST_RECORDS_META_DATA_SUCCESS:
        draft.expenseMetaData = expenseMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_EXPENSES_LIST_ERROR:
      case CREATE_EXPENSES_LIST_ERROR:
      case UPDATE_EXPENSES_LIST_ERROR:
      case DELETE_EXPENSES_LIST_ERROR:
      case LOAD_EXPENSES_ITEMS_LIST_ERROR:
      case LOAD_EXPENSES_CATEGORIES_LIST_ERROR:
      case LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS_ERROR:
      case LOAD_CASH_BANK_REPORT_LIST_ERROR:
      case LOAD_EXPENSE_REPORT_LIST_ERROR:
      case LOAD_PREFIX_SETTINGS_LIST_ERROR:
      case LOAD_FINANCIAL_YEAR_LIST_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_EXPENSES_LIST_RECORDS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
